import { gql } from '@apollo/client'

export const GET_PROJECT_BY_NAME = gql`
  query ($name: String!, $label_id: String!, $space_id: String) {
    getCampaignByName(name: $name, label_id: $label_id, space_id: $space_id) {
      campaigns {
        name
        id
        owner_id
        label_id
        artist {
          name
          facebook_id
          spotify_id
        }
      }
    }
  }
`
